import React from 'react';
import ConstructionWidget from 'components/widget/construction';
import { IConstruction } from 'store/state/selectors/insights/summaryTypes';



interface NewJobsProps {
  data: IConstruction;
}

export const NewJobs: React.FunctionComponent<NewJobsProps> = ({ data }) => {

  return (
    <ConstructionWidget onlyAccordion />
  );
};
